// extracted by mini-css-extract-plugin
module.exports = {"shareContainer":"SocialShare-module--shareContainer--3fDRY","icon":"SocialShare-module--icon--1AqWn"};